import React from "react";
function SidebarLeft(props: any) {
    return (
    <aside className="layout__sidebar layout__sidebar_second">
        <img src="./img/sidebarRight.png" alt="image description"/>
    </aside>
    )
}
export default SidebarLeft;